import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=ebb0d788"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports